import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasPermission } from '../../pages/Login/authUtils';
import Navbar from '../../components/NavBar/NavBar';

const PermissionRoute = ({ children, permission, isPublic = false }) => {
  const isAuthenticated = localStorage.getItem('authenticated') === 'true';

  // 🟡 Public route (like login)
  if (isPublic) {
    return isAuthenticated ? <Navigate to="/" /> : children;
  }

  // 🔐 Private route - login required
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // 🛡️ Permission-based route
  if (permission && !hasPermission(permission, `Route for "${permission}"`)) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <Navbar />
      {children}
    </>
  );
};

export default PermissionRoute;
